export enum LOSS {
  ZERO = 'ZERO',
  SMALL = 'SMALL',
  HUGE = 'HUGE',
}
